import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
const DEFAULT_CUT_NOTES_URL = 'https://www.digitalrebellion.com/cutnotes';
/**
 * Renders the static info box that comment-stream files use in place of a
 * media viewer. A comment stream has a timecode timeline but no file content,
 * so the body of the player area just explains where comments come from.
 */
const HekateCommentStream = forwardRef(function HekateCommentStream(props, ref) {
    const containerRef = useRef(null);
    const cutNotesUrl = props.cutNotesUrl || DEFAULT_CUT_NOTES_URL;
    useImperativeHandle(ref, () => ({
        getContainerElement: () => containerRef.current,
    }), []);
    return (_jsxs("div", { ref: containerRef, className: "pageseccolor hekate-comment-stream-info", style: {
            marginTop: '1em',
            padding: 10,
            fontSize: 15,
            border: 'thin solid #ccc',
        }, children: ["Comment streams allow you to add notes to Hekate without needing to upload a file. This is useful for sharing ", _jsx("a", { href: cutNotesUrl, children: "Cut Notes" }), " comments from an external sync source such as Pro Tools.", _jsxs("p", { children: ["You can only view and edit comments from this page. New comments must be added from ", _jsx("a", { href: cutNotesUrl, children: "Cut Notes" }), "."] })] }));
});
export default HekateCommentStream;
